export const doctorsArray = [
    {
        id:1,
        name:'James Njoroge',
        logo: require('../../assets/doctor.jpg'),
        pic:require('../../assets/doc7.jpg'),
        position:'Optical surgeon',
        profile:'A graduate from Moi University dental schools. 5 years of experience and commitment to work. ',
        department:'Optical Department',
        linkedin:'',
        facebook:'',
        instagram:''
    },
    {
        id:2,
        name:'Lucy Mwende',
        logo: require('../../assets/doctor.jpg'),
        pic:require('../../assets/doctor.jpg'),
        position:'Dentist',
        profile:'Nairobi University dental schools graduate. 3 years of experience and successful surgeries. ',
        department:'Dental Department',
        linkedin:'',
        facebook:'',
        instagram:''
    },
    {
        id:3,
        name:'Peter Gichuhi',
        logo: require('../../assets/doctor.jpg'),
        pic:require('../../assets/doc6.jpg'),
        position:'Heart surgeon',
        profile:'Kenyatta University medical schools. 7 years of experience with successful surgeries. ',
        department:'Heart Department',
        linkedin:'',
        facebook:'',
        instagram:''
    },
    {
        id:4,
        name:'Tracy Matilda',
        logo: require('../../assets/doctor.jpg'),
        pic:require('../../assets/doc4.jpg'),
        position:'Orthopedic surgeons',
        profile:'Moi University graduate. Expert in Orthopedic. 6 years of experience',
        department:'Orthopedic Department',
        linkedin:'',
        facebook:'',
        instagram:''
    },
    {
        id:5,
        name:'Peter Okoth',
        logo: require('../../assets/doctor.jpg'),
        pic:require('../../assets/doc2.jpg'),
        position:'Neurosurgeon ',
        profile:'Pwani University graduate. 3 years of experience and collaboration',
        department:'Neurosurgeon  Department',
        linkedin:'',
        facebook:'',
        instagram:''
    },
    {
        id:6,
        name:'Tracy Njeri',
        logo: require('../../assets/doctor.jpg'),
        pic:require('../../assets/doc3.jpg'),
        position:'Pychologist',
        profile:'A graduate from Multimidea university with a bachelors degree in medical psychology',
        department:'Councelling & Pyschologoy',
        linkedin:'',
        facebook:'',
        instagram:''
    },
    {
        id:7,
        name:'James Njoroge',
        logo: require('../../assets/doctor.jpg'),
        pic:require('../../assets/doc1.jpg'),
        position:'Pediatric surgery',
        profile:'A graduate from Moi University dental schools. 5 years of experience and commitment to work. ',
        department:'Pediatric Department',
        linkedin:'',
        facebook:'',
        instagram:''
    },
    {
        id:8,
        name:'Emmaculate Wangui',
        logo: require('../../assets/doctor.jpg'),
        pic:require('../../assets/doctor.jpg'),
        position:'Optical surgeon',
        profile:'A graduate from Moi University dental schools. 14 years of experience and commitment to work. ',
        department:'Dental Department',
        linkedin:'',
        facebook:'',
        instagram:''
    },
    {
        id:9,
        name:'Sulemita Akinyi',
        logo: require('../../assets/doctor.jpg'),
        pic:require('../../assets/doc5.jpg'),
        position:'Cardiothoracic surgeon.',
        profile:'A graduate from Kenyatta University Cardiothoracic schools. 9 years of experience and commitment. ',
        department:'Cardiothoracic Department',
        linkedin:'',
        facebook:'',
        instagram:''
    }
]